import $ from "jquery"
window.jQuery = $
window.$ = $
import "bootstrap"
import "admin-lte"
import "@fortawesome/fontawesome-free/js/all"
import Rails from '@rails/ujs';
Rails.start();